import type { FunctionComponent } from "react";
import { useCallback, useRef } from "react";
import { Tabs, TabList } from "@similarweb/ui-components";
import { abbrNumberFilter } from "app/filters/ngFilters";
import {
    NumberItem,
    Tab,
    TabWrapper,
    TextItem,
    TextWrapper,
    IconWrapper,
    CompareTabsWrapper,
    DotsLoaderWrapper,
} from "./styledComponents";
import { DotsLoader } from "@similarweb/ui-components";
import { isNull } from "lodash";

interface ITab {
    id: any;
    title: string;
    icon: string;
    numOfResults?: number;
    reverseEllipsis?: boolean;
}

interface ICompareTabsProps {
    tabs: ITab[];
    tabSelectedIndex: number;
    onTabSelectedCallback: (index: number) => void;
    tabPanels?: any;
    isLoading: boolean;
    hideResults?: boolean;
}

const TabWithLogo = (prop) => {
    const { title, icon, numOfResults, reverseEllipsis } = prop.tab as ITab;
    const { hideResults } = prop;
    const titleTooltipRef = useRef(null);
    return (
        <Tab className={prop.selected ? "selected" : null}>
            <IconWrapper>
                <img src={icon} />
            </IconWrapper>
            <TextWrapper>
                <TextItem $reverseEllipsis={reverseEllipsis}>
                    <span ref={titleTooltipRef}>{title}</span>
                </TextItem>
                {!hideResults ? (
                    prop.isLoading ? (
                        <DotsLoaderWrapper>
                            <DotsLoader />
                        </DotsLoaderWrapper>
                    ) : (
                        !isNull(numOfResults) && <NumberItem>({abbrNumberFilter()(numOfResults)})</NumberItem>
                    )
                ) : null}
            </TextWrapper>
        </Tab>
    );
};
export const CompareTabs: FunctionComponent<ICompareTabsProps> = (props) => {
    const { tabs, tabSelectedIndex, onTabSelectedCallback, tabPanels, isLoading, hideResults } = props;

    const onTabSelected = useCallback((index) => {
        onTabSelectedCallback(index);
    }, []);
    return (
        <CompareTabsWrapper>
            <Tabs
                selectedIndex={tabSelectedIndex}
                onSelect={onTabSelected}
            >
                <TabList>
                    {tabs
                        ? tabs.map((tab: ITab, index) => {
                              return (
                                  <TabWrapper
                                      key={tab.id}
                                      className={`tabs_${tabs.length}`}
                                      onClick={() => {
                                          onTabSelectedCallback(index);
                                      }}
                                      data-automation="tab-wrapper"
                                  >
                                      <TabWithLogo
                                          tab={tab}
                                          selected={index === tabSelectedIndex}
                                          isLoading={isLoading}
                                          hideResults={hideResults}
                                      />
                                  </TabWrapper>
                              );
                          })
                        : null}
                </TabList>
                {tabPanels}
            </Tabs>
        </CompareTabsWrapper>
    );
};
